import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {HelpBodyClosedLeadCompanyTypes} from './help-body-closed-lead-company-types';
import {HelpGraphicClosedLeadCompanyTypes} from './help-graphic-closed-lead-company-types';

type Props = {
    onClose: () => void;
    isOpen: boolean;
};

export class HelpClosedLeadCompanyTypes extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isOpen}
                    onClose={this.props.onClose}
                    noPadding={true}
                    closeButton={false}
                    preventBodyScroll={false}
                    maxHeight={500}
                >
                    <OnboardingPage
                        type='singlePage'
                        bodyComponent={<HelpBodyClosedLeadCompanyTypes />}
                        artBackgroundColor={colors.plumDk}
                        artImage={<HelpGraphicClosedLeadCompanyTypes />}
                        buttonText='Done'
                        onClose={this.props.onClose}
                    />
                </Modal>
            </div>
        );
    }
}
